import React from 'react'
import { defaultProps } from './index'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'
import VideoToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/VideoToolbarSection'
import { useNode } from '@craftjs/core'

export const HeroHomeSlideSettings = (settingsProps) => {
  const { props } = useNode((node) => ({
    customs: node.data.custom,
    props: node.data.props,
  }))

  return (
    <>
      {!settingsProps.floating && (
        <>
          <VideoToolbarSection defaultProps={defaultProps} props={props} initOpen={false} />
          <ImageToolbarSection defaultProps={defaultProps} initOpen={false} />
          <CtaToolbarSection defaultProps={defaultProps} initOpen={false} />
        </>
      )}
    </>
  )
}
